import { createSlice } from '@reduxjs/toolkit';
import { coursesAdapter, userCoursesAdapter } from "./sliceUtils"
import { processFetchingDashboardDetails } from "./dashboardSliceActions"


const initialState = {
    userCoursesDetails: userCoursesAdapter.getInitialState(null),
    coursesDetails: coursesAdapter.getInitialState(null),
};

const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(processFetchingDashboardDetails.fulfilled, (state, action) => {
                userCoursesAdapter.setAll(state.userCoursesDetails, action.payload?.usersCoursesDetails);
                coursesAdapter.setAll(state.coursesDetails, action.payload.courses);
            })
            .addCase(processFetchingDashboardDetails.rejected, (state, action) => {
                userCoursesAdapter.setAll(state.userCoursesDetails, []);
                coursesAdapter.setAll(state.coursesDetails, []);
            })
    },
});

export const { setUserCoursesDetails } = dashboardSlice.actions;

export default dashboardSlice.reducer;